import { combineReducers } from 'redux';

import { SET_IS_LOADING, SET_SHOW_MODAL } from '../actions/auth';

const isLoading = (state = true, { type, payload }) => {
    let nextState = state;

    if (type === SET_IS_LOADING) {
        nextState = payload;
    }
    return nextState;
};

const showModal = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SHOW_MODAL) {
        nextState = payload;
    }
    return nextState;
};

export default combineReducers({
    isLoading,
    showModal,
});
